import {action, configure, makeObservable, observable} from 'mobx';
import {router} from "@inertiajs/react";
import {route} from "ziggy-js";
import isEmpty from 'is-empty';
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import axios from "axios";
import {dataLayerPush, declOfNum} from "@/Helpers/Function";
import reachGoalVkAds from "@/Helpers/ReachGoalVkAds";

export default class BasketStoreMobx {
    // @observable basketCount = 0;
    // @observable basketProducts = [];
    @observable products = [];

    @observable textOrderRegistration = 'Перейти к оплате';
    // @observable textOrderRegistrationOneClick = 'Оформить заказ на';
    @observable statusSbpMessage = '';

    // Бонусы
    @observable bonuses = {
        totalBonusesAdd: 0,
        productsBonusesAdd: 0,
        bonusesBalance: 0,
        maximumSubtractBonuses: 0,
        subtractBonuses: 0,
    };
    @observable bonusesValues = 0;
    @observable subtractBonuses = null; // Сумма бонусов, подлежащая списанию
    @observable bonusesMsg = '';

    // Промокод
    @observable promo_id = null; // Номер промокода
    @observable promo_sum = 0; // Сумма промокода если применился
    promo_type = null; // Тип промокода, сумма или процент
    @observable promoCodeList = [];
    @observable promoCodeValues = '';
    @observable promoCodeErrMsg = '';
    @observable promoCodeMsg = '';

    // Процент скидки при онлайн оплате
    @observable paymentOnlineDiscount = 0;
    // Процент скидки при оплате через СБП
    @observable paymentOnlineDiscountSbp = 0;
    // Процент скидки при оплате Яндекс Пэй
    @observable paymentOnlineDiscountYandexPay = 0;
    // Процент скидки при оплате Яндекс Сплит
    @observable paymentOnlineDiscountYandexSplit = 0;
    // Процент скидки при оплате в кредит
    @observable paymentOnlineDiscountCreditSber = 0;
    // Процент скидки при оплате в рассрочку
    @observable paymentOnlineDiscountInstallmentSber = 0;
    // Процент скидки при оплате долями
    @observable paymentOnlineDiscountDolyame = 0;
    // Процент скидки при оплате Плайт
    @observable paymentOnlineDiscountPlajt = 0;
    // Количество бонусов за онлайн оплату
    @observable paymentOnlineBonusesAdd = 0;
    // Акции один в подарок
    saleOneCount = 0;
    textWarning = null;
    // Акция подарок - эксклюзивный питомец
    @observable saleGift = false;
    // Акция подарок - эксклюзивный питомец (данные для акции)
    @observable saleGiftData = [];

    // Заказы ожидающие оплату
    @observable dataUnpaidOrders = [];

    // Текущий способ доставки (определяется на сервере)
    @observable currentShippingMethod = 'pickup_point_delivery';
    // Способ доставки (По умолчанию ПВЗ)
    @observable shippingMethod = 'pickup_point_delivery';
    // Выбранный способ оплаты
    @observable valuePaymentMethod = '';
    @observable valuePassportChange = 'Российский';
    @observable flagPassportForm = true;
    @observable flagPassport = false;
    @observable flagPassportOneClick = false;

    @observable onlineDiscount = 0;
    @observable onlineDiscountText = '';
    // Окончательная сумма для оформления заказа
    @observable finalSum = 0;
    // Сумма за вычетом бонусов, промокода и т.д.
    @observable finalSumStart = 0;
    // Не изменяемые данные, рассчитываются на сервере
    finalSumNotDiscounts = 0; // Общая сумма всех позиций в корзине без учета скидок по акциям
    finalSumWithDiscounts = 0; // Общая сумма всех позиций в корзине за вычетом скидок по акциям
    finalSumDiscounts = 0; // Общая сумма скидок

    // Ошибки сервера
    @observable serverErrorOrders = '';
    @observable serverErrorOrderProcessing = '';
    @observable load = false;
    @observable formLoad = '';
    @observable sbpUrl = '';
    @observable loadSbp = '';
    @observable loadCount = false;
    // @observable serverMessage = '';

    // Заказы
    @observable dialogBasketOpen = false;
    @observable errorOrderMessage = 'Что то пошло не так...';

    // Тип доставки
    @observable deliveryValue = 'standardDelivery';
    // Ожидаемая дата доставки
    @observable deliveryDate = null;
    // Сумма доставки
    @observable deliverySum = 0;
    // Доставка с выбором
    @observable deliveryWithChoice = false;

    // Даты доставки, не изменяемые данные, рассчитываются на сервере
    minDate = null;
    minDateExpress = null;
    // Сумма экспресс доставки, не изменяемые данные, рассчитываются на сервере
    deliveryAmountExpress = 0;
    deliveryAmount = 0;
    deliveryFreeSum = 0;
    // УИД склада отгрузки
    guidShop = null;
    // Возможно только оплата онлайн
    paymentOnlyOnline = false;

    // API проверка промокода
    @observable basketPromoCodeLoader = '';
    @observable basketBonusesLoader = '';

    // Номер введенного сертификата
    @observable certificateNumber = '';
    // Примененные сертификаты
    @observable certificateData = [];
    @observable certificateLoader = false;
    // Ошибки применения сертификатов
    @observable certificateErrorMessage = '';
    // Итоговая сумма примененных сертификатов
    @observable certificateSum = 0;

    // Адрес доставки отмеченный как текущий в базе
    @observable currentDeliveryAddress = {};
    // Адрес доставки выбранный в модальном окне в корзине
    @observable selectedDeliveryAddress = {};
    // Адрес доставки для отображения в модальном окне в корзине
    @observable visualAddress = '';
    // Адрес в модалке выбора pvz or brandShop
    @observable deliveryInformationModalAddress = '';

    basketSettings = {};
    // // Полный список методов оплаты
    paymentMethods = {};
    @observable defaultPaymentMethod = '';

    // Запрет создания заказа
    @observable lockCreateOrder = false;

    constructor(rootStore) {
        makeObservable(this);
        configure({
            enforceActions: "never",
        });
        this.rootStore = rootStore;
    }

    basketStart = (props) => {
        const {basketData = {}, config = {}} = props;
        const {basketSettings = {}, defaultPaymentMethod = '', paymentMethod = {}} = config;
        this.basketSettings = basketSettings;
        this.defaultPaymentMethod = defaultPaymentMethod;
        this.paymentMethods = paymentMethod;
        if (this.valuePaymentMethod === '') {
            this.valuePaymentMethod = defaultPaymentMethod;
        }

        const {
            dataUnpaidOrders,
            saleHelp = {},
            bonuses,
            promoCode = {},
            certificateData,
            products,
            additionalData = {},
        } = basketData;

        const {
            count = 0,
            finalSumNotDiscounts = 0,
            finalSumWithDiscounts = 0,
            finalSumDiscounts = 0,
            minDate = null,
            minDateExpress = null,
            deliveryAmountExpress = 0,
            deliveryAmount = 0,
            deliveryFreeSum = 0,
            guidShop = null,
            currentDeliveryAddress = {},
            paymentOnlyOnline = false,
        } = additionalData;

        // 1 сценарий, все не оплаченные онлайн заказы
        this.dataUnpaidOrders = dataUnpaidOrders;

        // 2 сценарий, данные по корзине
        // Бонусы
        this.bonuses = bonuses;
        this.bonusesValues = bonuses.subtractBonuses;

        // Промокод
        const {
            promo_id = null,
            promo_sum = 0,
            promo_type = null,
            promo_list = [],
            message = '',
            errorMessage = ''
        } = promoCode;

        this.promo_id = promo_id;
        this.promo_sum = promo_sum;
        this.promo_type = promo_type;
        this.promoCodeList = promo_list;
        this.promoCodeMsg = message;
        this.promoCodeErrMsg = errorMessage;

        if (promo_id !== null) {
            this.promoCodeValues = promo_id;
        } else if (products.length === 0) {
            // Если корзина пуста, очистим введенный ранее промокод
            this.promoCodeValues = '';
        }

        // Данные по сертификатам
        this.certificateData = certificateData;

        // скидки при онлайн оплате
        const {
            onlineDiscount = 0,
            onlineDiscountSbp = 0,
            onlineDiscountCreditSber = 0,
            onlineDiscountInstallmentSber = 0,
            onlineDiscountDolyame = 0,
            onlineDiscountYandexPay = 0,
            onlineDiscountYandexSplit = 0,
            onlineDiscountPlajt = 0,
            onlineBonusesAdd = 0,
            saleOneCount = 0,
            textWarning = null,
            saleGift = false,
            saleGiftData = [],
        } = saleHelp;

        this.paymentOnlineDiscount = onlineDiscount;
        this.paymentOnlineDiscountSbp = onlineDiscountSbp;
        this.paymentOnlineDiscountCreditSber = onlineDiscountCreditSber;
        this.paymentOnlineDiscountInstallmentSber = onlineDiscountInstallmentSber;
        this.paymentOnlineDiscountDolyame = onlineDiscountDolyame;
        this.paymentOnlineDiscountYandexPay = onlineDiscountYandexPay;
        this.paymentOnlineDiscountYandexSplit = onlineDiscountYandexSplit;
        this.paymentOnlineDiscountPlajt = onlineDiscountPlajt;
        this.paymentOnlineBonusesAdd = onlineBonusesAdd;

        // акция 2=1
        this.saleOneCount = saleOneCount;
        this.textWarning = textWarning;

        // акция эксклюзивный питомец
        this.saleGift = saleGift;
        this.saleGiftData = saleGiftData;

        this.finalSum = finalSumWithDiscounts;

        // Не изменяемые данные
        this.finalSumNotDiscounts = finalSumNotDiscounts;
        this.finalSumWithDiscounts = finalSumWithDiscounts;
        this.finalSumDiscounts = finalSumDiscounts;

        // Даты доставки и стоимость
        this.minDate = minDate;
        this.minDateExpress = minDateExpress;
        this.deliveryAmount = deliveryAmount;
        this.deliveryAmountExpress = deliveryAmountExpress;
        this.deliveryFreeSum = deliveryFreeSum;
        if (count < 2) {
            this.deliveryWithChoice = false;
        }

        // УИД склада отгрузки
        this.guidShop = guidShop;
        this.paymentOnlyOnline = paymentOnlyOnline;

        this.products = products;

        // Рассчитываем дату доставки и стоимость
        if (this.deliveryValue === 'expressDelivery' && this.deliveryAmountExpress !== 0) {
            this.deliveryDate = this.minDateExpress;
            this.deliverySum = this.deliveryAmountExpress;
        } else {
            this.deliveryValue = 'standardDelivery';
            this.deliveryDate = this.minDate;
            this.deliverySum = this.deliveryAmount;
        }

        this.currentDeliveryAddress = currentDeliveryAddress ?? {};
        // Если есть адрес доставки
        if (this.currentDeliveryAddress?.delivery_type === 'pvz') {
            this.currentShippingMethod = 'pickup_point_delivery';
        } else if (this.currentDeliveryAddress?.delivery_type === 'brandShop') {
            this.currentShippingMethod = 'pickup_store';
        } else if (this.currentDeliveryAddress?.delivery_type === 'courier') {
            this.currentShippingMethod = 'courier_delivery';
        }

        // Контроль способов оплаты в зависимости от выбранного адреса доставки
        this.controlPaymentMethods(this.currentDeliveryAddress);

        this.bonusesControl();
        // this.isFittingControl();
        this.calculationPrice();

        this.basketPromoCodeLoader = '';
        this.basketBonusesLoader = '';
    };

    /**
     * Запрос на пересчет всей корзины, 1 этап
     */
    getBasket = () => {
        let data = {
            paymentMethod: this.valuePaymentMethod,
            bonuses: this.subtractBonuses,
        };
        if (!isEmpty(this.promoCodeValues) || this.basketPromoCodeLoader === 'load') {
            data.promoCodeValue = this.promoCodeValues;
        }

        router.post(
            '/basket',
            data,
            {
                preserveScroll: true,
            }
        );
    };

    /**
     * Запрос на пересчет всей корзины, 2 этап
     */
    getBasketGoToCheckout = () => {
        this.lockCreateOrder = true;

        let data = {
            deliveryWithChoice: this.deliveryWithChoice,
            paymentMethod: this.valuePaymentMethod,
            promoCodeValue: this.promoCodeValues,
            certificateData: this.certificateData,
            bonuses: this.subtractBonuses,
        };

        router.post(
            '/go-to-checkout',
            data,
            {
                preserveScroll: true,
                onSuccess: (page) => {
                    this.lockCreateOrder = false;
                },
                onError: () => {
                    this.lockCreateOrder = false;
                },
            }
        );
    };

    /**
     * Удаление изделия из корзины
     * @param productId
     * @param productDataId
     * @param type
     */
    deleteBasket = async (productId = null, productDataId = null, type = 'item') => {
        try {
            const response = await axios.post(route('basket.delete'), {
                productId: productId,
                productDataId: productDataId,
                type: type
            });

            const {success} = response.data;
            if (success.status) {
                const products = type === 'item' ? this.products.filter((el) => el.product_id === productId && el.product_data.id === productDataId) : this.products;
                dataLayerPush('remove_from_cart', 'catalog', 'removeFromCart', 'product', '', products);

                this.getBasket();
            }
        } catch (e) {
            console.log('e', e);
        }
    };

    // /**
    //  * Добавить украшение в корзину или изменить количество
    //  * @param product_id
    //  * @param productData_id
    //  * @param price
    //  * @param count
    //  * @param flagSnackbar
    //  * @param operationType
    //  * @returns {Promise<void>}
    //  */
    // @action addOrUpdateProduct = async (product_id, productData_id, price, count = 1, flagSnackbar = true, operationType = 'create') => {
    //     try {
    //         const response = await axios.post(route('basket.addOrUpdate'), {
    //             productId: product_id,
    //             productDataId: productData_id,
    //             count: count,
    //             returnProduct: flagSnackbar,
    //             operationType: operationType,
    //         });
    //
    //         const {success = {}} = response.data;
    //         const {status = false, data = [], errors = []} = success;
    //         const addSnackbarsStore = this.rootStore.addSnackbarsStore;
    //         if (status) {
    //             this.basketProductsUpdate(data['basketProducts']);
    //
    //             if (flagSnackbar) {
    //                 addSnackbarsStore.data = {
    //                     text: `Товар добавлен!`,
    //                     autoHide: 3000,
    //                     severity: 'success',
    //                     basket: true
    //                 };
    //                 reachGoalYM('add_basket');
    //                 reachGoalGA('add_basket');
    //
    //                 const products = data['products'].map((el) => {
    //                     return {
    //                         ...el,
    //                         'count': count,
    //                         'price': price,
    //                     };
    //                 });
    //
    //                 dataLayerPush('add_to_cart', 'catalog', 'addToCart', 'product', '', products);
    //
    //                 // Отправка цели VK
    //                 reachGoalVkAds('addToCart', price, product_id);
    //
    //                 addSnackbarsStore.handleClickAddSnackbars();
    //             }
    //
    //             if (location.pathname === '/basket') {
    //                 this.getBasket();
    //             }
    //         } else {
    //             const text = errors.errorMessage ?? 'Произошла ошибка при изменении товара!';
    //             addSnackbarsStore.data = {
    //                 text: text,
    //                 autoHide: 3000,
    //                 severity: 'success',
    //                 basket: false
    //             };
    //             addSnackbarsStore.handleClickAddSnackbars();
    //         }
    //     } catch (e) {
    //         console.log('e', e);
    //         this.loadCount = false;
    //         const addSnackbarsStore = this.rootStore.addSnackbarsStore;
    //         addSnackbarsStore.data = {
    //             text: `Произошла ошибка при изменении товара!`,
    //             autoHide: 3000,
    //             severity: 'success',
    //             basket: false
    //         };
    //         addSnackbarsStore.handleClickAddSnackbars();
    //     }
    // };

    // /**
    //  * Добавление / изменение набора
    //  * @param productsSet
    //  * @param flagSnackbar
    //  * @returns {Promise<void>}
    //  */
    // @action addOrUpdateProductSet = async (productsSet, flagSnackbar = true) => {
    //     try {
    //         const response = await axios.post(route('basket.addOrUpdateSet'), {
    //             products: productsSet,
    //             returnProduct: flagSnackbar
    //         });
    //
    //         const {success = {}} = response.data
    //         const addSnackbarsStore = this.rootStore.addSnackbarsStore;
    //         if (success.status) {
    //             this.basketProductsUpdate(success.basketProducts);
    //
    //             if (flagSnackbar) {
    //                 addSnackbarsStore.data = {
    //                     text: `Товары добавлены!`,
    //                     autoHide: 3000,
    //                     severity: 'success',
    //                     basket: true
    //                 };
    //                 reachGoalYM('add_basket');
    //                 reachGoalGA('add_basket');
    //
    //                 const products = success.products.map((el) => {
    //                     return {
    //                         ...el,
    //                         'count': 1,
    //                     };
    //                 });
    //
    //                 dataLayerPush('add_to_cart', 'catalog', 'addToCart', 'product', '', products);
    //
    //                 addSnackbarsStore.handleClickAddSnackbars();
    //             }
    //
    //             if (location.pathname === '/basket') {
    //                 this.getBasket();
    //             }
    //         } else {
    //             addSnackbarsStore.data = {
    //                 text: 'Произошла ошибка при изменении товаров!',
    //                 autoHide: 3000,
    //                 severity: 'success',
    //                 basket: false
    //             };
    //             addSnackbarsStore.handleClickAddSnackbars();
    //         }
    //     } catch (e) {
    //         console.log('e', e);
    //         this.loadCount = false;
    //         const addSnackbarsStore = this.rootStore.addSnackbarsStore;
    //         addSnackbarsStore.data = {
    //             text: `Произошла ошибка при изменении товаров!`,
    //             autoHide: 3000,
    //             severity: 'success',
    //             basket: false
    //         };
    //         addSnackbarsStore.handleClickAddSnackbars();
    //     }
    // };

    /**
     * Меняем способ доставки (pvz, brandShop, courier)
     * @param type
     */
    @action changeShippingMethod(type) {
        try {
            this.currentShippingMethod = type;
            this.shippingMethod = type;
            this.visualAddress = '';

            this.selectedDeliveryAddress.operationMode = '';
            this.selectedDeliveryAddress.phone = '';
            this.selectedDeliveryAddress.howToGet = '';
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Определяем способ оплаты
     * @param method
     */
    @action handlePaymentMethodChange(method) {
        // Не меняем способ оплаты, если был применен сертификат и сумма к оплате составила 0 р
        if (this.certificateData.length !== 0 && this.finalSum === 0) {
            return;
        }

        this.valuePaymentMethod = method.methodName;
        this.getBasketGoToCheckout();
        dataLayerPush('add_payment_info', 'checkout', 'addPaymentInfo', 'product', '',
            this.products,
            {
                'shipping_tier': this.currentDeliveryAddress?.delivery_type,
                'payment_type': this.valuePaymentMethod
            }
        );
    }

    /**
     * Меняем форму для паспорта (Российский/Иностранный)
     * @param event
     */
    @action changePassportForm = (event) => {
        this.valuePassportChange = event.target.value;
        if (this.valuePassportChange.toLowerCase() === 'российский') {
            this.flagPassportForm = true;
        } else {
            this.flagPassportForm = false;
        }
    };

    /**
     * Расчет общего прайса
     */
    @action calculationPrice = () => {
        if (this.products.length === 0) {
            return false;
        }

        // Присваиваем стартовую сумму перед расчетами
        this.finalSum = this.finalSumWithDiscounts;

        // Вычитаем сумму промокода
        if (this.promo_sum !== 0) {
            this.finalSum = this.finalSum - this.promo_sum;
        }

        // Вычитаем сумму бонусов
        if (this.bonuses.subtractBonuses !== 0) {
            this.finalSum = this.finalSum - this.bonuses.subtractBonuses;
        }

        this.finalSumStart = this.finalSum;

        this.onlineAdd();
        this.passportControl();
    };

    /**
     * Пересчет скидок и итоговой суммы
     */
    @action onlineAdd = () => {
        const {yandexSplit = {}, installment = {}, credit = {}, dolyame = {}} = this.paymentMethods;
        if ((this.valuePaymentMethod === 'byCash' || this.valuePaymentMethod === 'bankCard') && (this.paymentOnlyOnline || this.certificateData.length > 0)) {
            this.valuePaymentMethod = this.defaultPaymentMethod;
        }
        if (this.valuePaymentMethod === 'yandexSplit'
            && ((this.finalSumStart - Math.round(this.paymentOnlineDiscountYandexSplit * this.finalSumStart / 100)) < yandexSplit.min
                || (this.finalSumStart - Math.round(this.paymentOnlineDiscountYandexSplit * this.finalSumStart / 100)) > yandexSplit.max)) {
            this.valuePaymentMethod = this.defaultPaymentMethod;
        }
        if (this.valuePaymentMethod === 'installment'
            && ((this.finalSumStart - Math.round(this.paymentOnlineDiscountInstallmentSber * this.finalSumStart / 100)) < installment.min
                || (this.finalSumStart - Math.round(this.paymentOnlineDiscountInstallmentSber * this.finalSumStart / 100)) > installment.max)) {
            this.valuePaymentMethod = this.defaultPaymentMethod;
        }
        if (this.valuePaymentMethod === 'credit'
            && ((this.finalSumStart - Math.round(this.paymentOnlineDiscountCreditSber * this.finalSumStart / 100)) < credit.min
                || (this.finalSumStart - Math.round(this.paymentOnlineDiscountCreditSber * this.finalSumStart / 100)) > credit.max)) {
            this.valuePaymentMethod = this.defaultPaymentMethod;
        }
        if (this.valuePaymentMethod === 'dolyame'
            && (this.finalSumStart - Math.round(this.paymentOnlineDiscountDolyame * this.finalSumStart / 100)) > dolyame.max) {
            this.valuePaymentMethod = this.defaultPaymentMethod;
        }
        if (this.valuePaymentMethod === 'plajt'
            && ((this.finalSumStart - Math.round(this.paymentOnlineDiscountPlajt * this.finalSumStart / 100)) < this.basketSettings.paymentPlajtMin
                || (this.finalSumStart - Math.round(this.paymentOnlineDiscountPlajt * this.finalSumStart / 100)) > this.basketSettings.paymentPlajtMax)) {
            this.valuePaymentMethod = this.defaultPaymentMethod;
        }

        if (this.valuePaymentMethod === 'online') {
            this.textOrderRegistration = 'Перейти к оплате';
            this.onlineDiscount = Math.round(this.paymentOnlineDiscount * this.finalSumStart / 100);
            this.onlineDiscountText = 'Скидка при оплате онлайн';
            this.bonuses.totalBonusesAdd = this.bonuses.productsBonusesAdd + this.paymentOnlineBonusesAdd;
        } else if (this.valuePaymentMethod === 'certificate') {
            this.textOrderRegistration = 'Оформить заказ';
            this.onlineDiscount = Math.round(this.paymentOnlineDiscount * this.finalSumStart / 100);
            this.onlineDiscountText = 'Скидка при оплате онлайн';
            this.bonuses.totalBonusesAdd = this.bonuses.productsBonusesAdd;
        } else if (this.valuePaymentMethod === 'installment') {
            this.textOrderRegistration = 'Оформить в рассрочку';
            this.onlineDiscount = Math.round(this.paymentOnlineDiscountInstallmentSber * this.finalSumStart / 100);
            this.onlineDiscountText = 'Скидка при оплате в рассрочку';
            this.bonuses.totalBonusesAdd = this.bonuses.productsBonusesAdd + this.paymentOnlineBonusesAdd;
        } else if (this.valuePaymentMethod === 'credit') {
            this.textOrderRegistration = 'Оформить в кредит';
            this.onlineDiscount = Math.round(this.paymentOnlineDiscountCreditSber * this.finalSumStart / 100);
            this.onlineDiscountText = 'Скидка при оплате «Покупай со Сбером»';
            this.bonuses.totalBonusesAdd = this.bonuses.productsBonusesAdd + this.paymentOnlineBonusesAdd;
        } else if (this.valuePaymentMethod === 'sbp') {
            this.textOrderRegistration = 'Перейти к оплате';
            this.onlineDiscount = Math.round(this.paymentOnlineDiscountSbp * this.finalSumStart / 100);
            this.onlineDiscountText = 'Скидка при оплате через СБП';
            this.bonuses.totalBonusesAdd = this.bonuses.productsBonusesAdd + this.paymentOnlineBonusesAdd;
        } else if (this.valuePaymentMethod === 'yandexPay') {
            this.textOrderRegistration = 'Перейти к оплате';
            this.onlineDiscount = Math.round(this.paymentOnlineDiscountYandexPay * this.finalSumStart / 100);
            this.onlineDiscountText = 'Скидка при оплате Я.Пей';
            this.bonuses.totalBonusesAdd = this.bonuses.productsBonusesAdd + this.paymentOnlineBonusesAdd;
        } else if (this.valuePaymentMethod === 'yandexSplit') {
            this.textOrderRegistration = 'Перейти к оплате';
            this.onlineDiscount = Math.round(this.paymentOnlineDiscountYandexSplit * this.finalSumStart / 100);
            this.onlineDiscountText = 'Скидка при оплате Я.Сплит';
            this.bonuses.totalBonusesAdd = this.bonuses.productsBonusesAdd + this.paymentOnlineBonusesAdd;
        } else if (this.valuePaymentMethod === 'dolyame') {
            this.textOrderRegistration = 'Оформить долями';
            this.onlineDiscount = Math.round(this.paymentOnlineDiscountDolyame * this.finalSumStart / 100);
            this.onlineDiscountText = 'Скидка при оплате долями';
            this.bonuses.totalBonusesAdd = this.bonuses.productsBonusesAdd + this.paymentOnlineBonusesAdd;
        } else if (this.valuePaymentMethod === 'plajt') {
            this.textOrderRegistration = 'Оплатить Плайт';
            this.onlineDiscount = Math.round(this.paymentOnlineDiscountPlajt * this.finalSumStart / 100);
            this.onlineDiscountText = 'Скидка при оплате Плайт';
            this.bonuses.totalBonusesAdd = this.bonuses.productsBonusesAdd + this.paymentOnlineBonusesAdd;
        } else {
            this.textOrderRegistration = 'Оформить заказ';
            this.onlineDiscount = 0;
            this.onlineDiscountText = '';
            this.bonuses.totalBonusesAdd = this.bonuses.productsBonusesAdd;
        }
        this.finalSum = this.finalSumStart - this.onlineDiscount;

        this.finalSum = this.finalSum + this.deliverySum;

        // Применяем сертификат
        this.calculationCertificate();

        if (this.finalSum === 0 && this.certificateSum > 0 && this.valuePaymentMethod !== 'certificate') {
            this.valuePaymentMethod = 'certificate';
            this.onlineAdd();
        } else if (this.finalSum > 0 && this.valuePaymentMethod === 'certificate') {
            this.valuePaymentMethod = this.defaultPaymentMethod;
            this.onlineAdd();
        }
    };

    /**
     * Показываем форму с паспортными данными
     */
    @action passportControl = () => {
        const method = this.paymentMethods[this.valuePaymentMethod] ?? {};
        if (method.is_online === 1 && this.finalSum >= this.basketSettings.paymentOnline) {
            this.flagPassport = true;
        } else if (this.valuePaymentMethod == 'bankCard' && this.finalSum >= this.basketSettings.paymentBankCard) {
            this.flagPassport = true;
        } else if (this.valuePaymentMethod == 'byCash' && this.finalSum >= this.basketSettings.paymentByCash) {
            this.flagPassport = true;
        } else {
            this.flagPassport = false;
        }
    };

    /**
     * Открытие модалки "Ошибка при заказе"
     */
    @action openDialogBasket = () => {
        this.dialogBasketOpen = true;
    };

    /**
     * Закрытие модалки "Ошибка при заказе"
     */
    @action closeDialogBasket = () => {
        this.dialogBasketOpen = false;
        this.serverErrorOrders = '';
    };

    /**
     * Удаляем заказ из списка не оплаченных спустя 20 минут
     * @param id
     */
    @action deleteUnpaidOrders = (id) => {
        this.dataUnpaidOrders = this.dataUnpaidOrders.filter((el) => id !== el.id)
    };

    @action bonusesControl = () => {
        if (this.bonuses.maximumSubtractBonuses === 0) {
            if (this.bonuses.bonusesBalance === 0) {
                this.bonusesMsg = 'Нет бонусов для списания';
            } else {
                this.bonusesMsg = 'На счете ' + this.bonuses.bonusesBalance.toLocaleString('ru') +
                    ' бонусов, но они недоступны для выбранных украшений в течение действия текущих акций';
            }
        } else {
            this.bonusesMsg = 'Можно списать ' + this.bonuses.maximumSubtractBonuses.toLocaleString('ru') +
                ' из ' + this.bonuses.bonusesBalance.toLocaleString('ru') + ' ' +
                declOfNum(this.bonuses.bonusesBalance, ['бонуса', 'бонусов', 'бонусов']);
        }
    };

    /**
     * Изменяем бонусы
     * @param e
     */
    @action bonusesChangeValue = (e) => {
        try {
            // Удаляем ведущие нули с помощью регулярного выражения
            this.bonusesValues = e.target.value.replace(/^0+/, '');
        } catch (e) {
            console.log('e', e);
        }
    };

    /**
     * Отправляем сумму бонусов для расчета списания введенную пользователем
     * @param resetFlag
     * @returns {boolean}
     */
    @action bonusesChange = (resetFlag = false) => {
        try {
            if (this.basketBonusesLoader === 'load') return false;

            this.basketBonusesLoader = 'load';
            this.bonusesValues = resetFlag ? 0 : Math.min(Number(this.bonusesValues), this.bonuses.maximumSubtractBonuses);
            this.subtractBonuses = this.bonusesValues;

            if (location.pathname === '/basket') {
                // this.subtractBonuses = this.bonusesValues;
                this.getBasket();
            }
            if (location.pathname === '/go-to-checkout') {
                // this.subtractBonuses = this.bonusesValues;
                this.getBasketGoToCheckout();
            }
        } catch (e) {
            this.basketBonusesLoader = '';
            console.log('e', e);
        }
    };

    /**
     * Изменяем введенный промокод
     * @param e
     */
    @action promoCodeChangeValue = (e) => {
        try {
            this.promoCodeValues = e.target.value;
        } catch (e) {
            console.log('e', e);
        }
    };

    /**
     * Применяем/скидываем промокод
     * @param resetFlag
     * @returns {boolean}
     */
    @action promoCodeChange = (resetFlag = false) => {
        try {
            if (this.basketPromoCodeLoader === 'load') return false;

            this.basketPromoCodeLoader = 'load';

            if (resetFlag) {
                this.promoCodeValues = '';
                this.promoCodeErrMsg = '';
                this.promoCodeMsg = '';
                this.promo_id = null;
                this.promo_sum = 0;
                this.promo_type = null;
            }

            if (location.pathname === '/basket') {
                this.getBasket();
            }
            if (location.pathname === '/go-to-checkout') {
                this.getBasketGoToCheckout();
            }
        } catch (e) {
            this.basketPromoCodeLoader = '';
            console.log('e', e);
        }
    };

    /**
     * Контроль способов оплаты в зависимости от выбранного адреса доставки
     * @param element
     */
    @action controlPaymentMethods = (element = {}) => {
        try {
            const {haveCashless = 1, haveCash = 1} = element;

            if (this.valuePaymentMethod === 'byCash' && haveCash === 0) {
                this.valuePaymentMethod = this.defaultPaymentMethod;
            } else if (this.valuePaymentMethod === 'bankCard' && haveCashless === 0) {
                this.valuePaymentMethod = this.defaultPaymentMethod;
            }
        } catch (e) {
            console.log('e', e);
        }
    };

    /**
     * Выбор/Отмена экспресс доставки
     */
    changeExpressDelivery = (event) => {
        this.deliveryValue = event.target.value;

        if (this.deliveryValue === 'expressDelivery') {
            // Если был выбран способ оплаты при получении и выбрали экспресс доставку, сбрасываем на дефолтный способ
            if (this.valuePaymentMethod === 'bankCard' || this.valuePaymentMethod === 'byCash') {
                this.valuePaymentMethod = this.defaultPaymentMethod;
            }
            this.deliveryDate = this.minDateExpress;
            this.deliverySum = this.deliveryAmountExpress;
        } else {
            this.deliveryDate = this.minDate;
            this.deliverySum = this.deliveryAmount;
        }

        this.onlineAdd();
    };

    /**
     * Выбор/Отмена доставки с выбором
     */
    changeDeliveryWithChoice = (event) => {
        this.deliveryWithChoice = event.target.checked;
        this.getBasketGoToCheckout();
    };

    /**
     * Обработчик ввода сертификата
     * @param e
     */
    certificateChange = (e) => {
        try {
            // Стираем ошибку при вводе сертификата
            if (this.certificateErrorMessage !== '') {
                this.certificateErrorMessage = '';
            }

            this.certificateNumber = e.target.value;
        } catch (e) {
            console.log('e', e);
        }
    };

    /**
     * Поиск и применение сертификата, запрос на сервер
     * @param certificateNumber
     * @returns {Promise<void>}
     */
    applyCertificate = async (certificateNumber) => {
        try {
            if (this.certificateLoader) return;

            this.certificateLoader = true;
            if (isEmpty(certificateNumber)) {
                this.certificateErrorMessage = 'Введите сертификат!';
                return;
            }

            const el = this.certificateData.find(item => item.number === certificateNumber);
            if (el !== undefined) {
                this.certificateErrorMessage = 'Сертификат уже применен!';
                return;
            }

            if (this.finalSum === 0) {
                this.certificateErrorMessage = 'Невозможно применить сертификат!';
                return;
            }

            const values = {
                certificateNumber: certificateNumber
            };

            // Стучимся на сервак
            const response = await axios.post('/apply-certificate', values);

            const {success} = response.data;
            const {certificate} = success;

            this.certificateData.push(certificate);
            this.calculationPrice();
            this.certificateNumber = '';
            this.certificateErrorMessage = '';
            this.certificateLoader = false;
        } catch (e) {
            console.log('e', e);
            this.certificateErrorMessage = e.response.data.message;
        }
    };

    /**
     * Удалить / отменить сертификат
     * @param certificate
     */
    deleteCertificate = (certificate) => {
        this.certificateData = this.certificateData.filter((el) => certificate.id !== el.id);
        this.calculationPrice();
    };

    /**
     * Вычитаем сумму сертификата из итоговой суммы заказа
     */
    calculationCertificate = () => {
        this.certificateSum = 0;
        if (this.certificateData.length === 0) {
            return;
        }

        let certificateSum = 0, writeSum = 0, finalSum = this.finalSum;
        this.certificateData = this.certificateData.map((el) => {
            if (finalSum !== 0) {
                writeSum = Math.min(el.balance, finalSum);
                finalSum = finalSum - writeSum;
                el.writeSum = writeSum;
            }
            certificateSum = certificateSum + writeSum;

            return el;
        });

        this.finalSum = finalSum;
        this.certificateSum = certificateSum;
    };

    /**
     * Отметить / Снять все флажки у товара
     * @param event
     */
    @action changeCheckboxAll = (event) => {
        this.updateCheckedBasket(event.target.checked);
    };

    /**
     * Отметить / Снять флажок у товара
     * @param event
     * @param productDataId
     */
    @action changeCheckboxOne = (event, productDataId) => {
        this.updateCheckedBasket(event.target.checked, productDataId);
    };

    /**
     * Обновление чек боксов, запрос на сервер
     * @param checked
     * @param productDataId
     * @returns {Promise<void>}
     */
    @action updateCheckedBasket = async (checked, productDataId = null) => {
        await axios.post(route('changeCheckbox'), {productDataId: productDataId, checked: checked});

        this.getBasket();
    }

    /**
     * Выбрать адрес доставки из списка доступных адресов пользователя
     * @param el
     */
    @action changeDeliveryAddress = (el) => {
        const values = {
            ...el,
            deliveryWithChoice: this.deliveryWithChoice,
            paymentMethod: this.valuePaymentMethod,
            promoCodeValue: this.promoCodeValues,
            certificateData: this.certificateData,
            bonuses: this.bonusesValues,
        };
        if (el && el.status && el.id !== this.currentDeliveryAddress?.id) {
            router.post(route('changeDeliveryAddress'), values, {
                onSuccess: (page) => {
                    this.rootStore.modalStore.closeDialogDeliveryAddresses();
                    dataLayerPush('add_shipping_info', 'checkout', 'addShippingInfo', 'product', '',
                        this.products,
                        {
                            'shipping_tier': el.delivery_type,
                            'payment_type': this.valuePaymentMethod
                        }
                    );
                },
                onError: () => {
                    //
                },
            });
        }
    }

    /**
     * Удалить адрес доставки из списка
     * @param event
     * @param el
     */
    @action deleteDeliveryAddress = (event, el) => {
        event.stopPropagation();
        const values = {
            ...el,
            paymentMethod: this.valuePaymentMethod,
            promoCodeValue: this.promoCodeValues,
            certificateData: this.certificateData,
            bonuses: this.bonusesValues,
        };
        router.post(route('deleteDeliveryAddress'), values, {
            onSuccess: (page) => {
                //
            },
            onError: () => {
                //
            },
        });
    }

    /**
     * Скрыть выбранный адрес доставки
     */
    @action closeVisualAddress = () => {
        this.visualAddress = '';
    }
}
